import { convertToIsoDateTime } from "../datetime";

export const customerInteractionCreatePayload = (
  data,
  siteGuid,
  linkedAlertData,
) => {
  const { customer, customerId } = data;

  return {
    ...data,
    interactionDate: convertToIsoDateTime(
      data.interactionDate,
      data.interactionTime,
    ),
    endDateOfBreak: data.reviewDate ? `${data.reviewDate}T00:00:00Z` : null,
    providedLeaflet: data.providedLeaflet ?? false,
    seekHelp: data.seekHelp ?? false,
    selfExclude: data.selfExclude ?? false,
    discussedSelfExclusion: data.discussedSelfExclusion ?? false,
    otherOutcome: data.otherOutcome,
    reasonNotProvidedLeaflet: data.reasonNotProvidedLeaflet,
    reasonNotSeekingHelp: data.reasonNotSeekHelp,
    reasonNotDiscussedSelfExclusion: data.reasonNotDiscussedSelfExclusion,
    reasonNotSelfExclude: data.reasonNotSelfExclude,
    reviewDate: data.setReminder
      ? convertToIsoDateTime(data.reminderDate, data.reminderTime)
      : null,
    comments: data.comments,
    outcome: { id: data.outcome, name: "" },
    actionTaken: { id: data.actionTaken, name: "" },
    reason: { id: data.reason, name: "" },
    site: { guid: siteGuid, id: 0 },
    customerId: customerId ?? customer.id,
    customer:
      customerId || customer.id
        ? null
        : {
            ...customer,
            address1: "",
            address2: "",
            town: "",
            postcode: "",
          },
    alertIds: linkedAlertData.map((x) => x.id),
  };
};
